import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrlApi } from "../../proxy";
/*--------------------------GET ALL VISIONS-----------------------------*/
export const getAllvisions = createAsyncThunk(
  "visionMessions/getAllvisions",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}vision/mission`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
